import { I04CONVVOLENER_State } from '@batical/types/src'

const I04CONVVOLENER: I04CONVVOLENER_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_pci: 10.4,
  gaz_uuid: '7E3D48EC-7E15-4FB7-AE58-0D558DFBA0B3',
  in_volume: 3.0,
  res_energie: 0.0,
  mode: 'none',
  calcul_code: 'I04CONVVOLENER'
}

export default I04CONVVOLENER
